import React, { createContext, useReducer } from "react";

export const LanguageContext = createContext();

const initialState = {
    darkMode: false,
    selected: null
};


const languageReducer = (state, action) => {

    console.log("languageReducer", action);

    if (action.selected) {
        return { selected: action.selected}
    }

    // switch (action.type) {
    //     case "LIGHTMODE":
    //         return { darkMode: false };
    //     case "DARKMODE":
    //         return { darkMode: true };
    //     default:
    //         return state;
    // }
    return state;
};

export function LanguageProvider(props) {
    const [state, dispatch] = useReducer(languageReducer, initialState);

    return <LanguageContext.Provider value={{ state, dispatch }}>{props.children}</LanguageContext.Provider>;
}
